<template>
  <nav class="footer-links">
    <PagePart part-key="footer_links" wrapper-tag="section" />
    <PagePart part-key="footer_links_about" wrapper-tag="section" />
    <PagePart part-key="footer_links_sitemap" wrapper-tag="section" />
  </nav>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FooterLinksDesktop extends Vue {}

export default toNative(FooterLinksDesktop)
</script>

<style scoped>
nav {
  min-height: 12em;
  display: grid;
  padding: 2em 5em;
  --grid-layout-gap: 3em;
  --grid-column-count: 3;
  --grid-item-min-width: 14em;
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item-max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(max(var(--grid-item-min-width), var(--grid-item-max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
  row-gap: var(--grid-layout-gap);
  position: relative;
  z-index: 1;
}

nav :deep(h2) {
  font-size: 1.3em;
}

nav :deep(a) {
  color: var(--text-default);
  text-decoration: none;
  display: block;
  font-size: 1em;
  line-height: 1.75;
}

nav :deep(a:hover) {
  text-decoration: underline;
}
</style>
